import { SVGProps } from '@components/Icon/types';

export const Diet = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <path
      d="M15.3794 1.6875C15.3294 1.68734 15.2788 1.69189 15.2278 1.70215C14.1195 1.92375 13.0319 2.82406 12.4431 3.96241C8.37168 4.3361 5.25 9.29549 5.25 15.5625C5.25 19.2844 8.27812 22.3125 12 22.3125C15.7219 22.3125 18.75 19.2844 18.75 15.5625C18.75 13.7303 18.0635 12.4566 17.3994 11.2251C16.7443 10.009 16.125 8.86013 16.125 7.125C16.125 5.77573 15.2807 4.62307 14.094 4.1587C14.5181 3.61873 15.077 3.26196 15.5222 3.17286C15.9283 3.09186 16.1917 2.69641 16.1104 2.29029C16.0395 1.93493 15.7292 1.68864 15.3794 1.6875ZM12.9441 5.43824C13.8714 5.4419 14.625 6.19689 14.625 7.125C14.625 9.2385 15.3982 10.6714 16.0796 11.9363C16.7077 13.1018 17.25 14.1086 17.25 15.5625C17.25 18.4575 14.895 20.8125 12 20.8125C9.105 20.8125 6.75 18.4575 6.75 15.5625C6.75 10.0089 9.49693 5.4871 12.884 5.4397C12.9054 5.44185 12.9236 5.43802 12.9441 5.43824ZM12 11.4375C10.2319 11.4375 9 13.6247 9 15.5874C9 17.5599 10.2337 18.9375 12 18.9375C13.7662 18.9375 15 17.5599 15 15.5874C15 13.6247 13.7681 11.4375 12 11.4375ZM12 12.9375C12.6611 12.9375 13.5 14.1849 13.5 15.5874C13.5 16.7109 12.9113 17.4375 12 17.4375C11.0887 17.4375 10.5 16.7109 10.5 15.5874C10.5 14.1849 11.3389 12.9375 12 12.9375Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'diet';
